<form [formGroup]="documentForm" class="create-document-wrapper">
  <div class="form-group select">
    <label class="label-title" for="document-type">Selecione o tipo documento:</label>
    <lib-select [options]="documentTypes" formControlName="type" placeholder="Selecione o tipo" size="m"></lib-select>
  </div>

  <div class="form-group" *ngIf="hasSelectedType">
    <p>Onde vai ficar o digitador</p>
  </div>

  <div class="actions" *ngIf="hasSelectedType">
    <button libButton appearance="primary" size="m" type="submit" (click)="onSubmit()" [disabled]="!documentForm.valid">
      ENVIAR DOCUMENTO
    </button>
    <button libButton appearance="outline" size="m" type="button" (click)="onCancel()">CANCELAR</button>
  </div>
</form>
